// ** React Imports
import React, {ReactNode} from 'react'
import {Navigate, Outlet} from 'react-router-dom'

// ** Hook Import
import {UserCredentials, userStorage} from "../utils/localStorage";

interface Props {
  children?: ReactNode
}

const BaseLayout = ({ children }: Props) => {
    const user: UserCredentials = userStorage.get();

    if (!user)
        return (
            <Navigate to={'/login'}/>
        )
    
    return (
        <>
            {children}
    
            <Outlet />
        </>
      )
}

export default BaseLayout
